// 국내 정산계좌 조회 유틸 (2026-08-06 보안 P1②)
// users 문서는 로그인 전체 공개(read: isSignedIn)라 계좌번호가 전 회원에게 노출됐다.
// → 계좌는 paymentProfiles/{회사uid}.domesticBank (본인·직원·관리자만 접근)로 이전.
// 명세서에는 발행 시점에 스냅샷으로 담기므로 거래 상대(치과)는 명세서에서 계속 본다.
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * @param {string} companyUid 회사(대표) uid — paymentProfiles 문서 ID
 * @param {object|null} legacyUserData 마이그레이션 전 users 문서 데이터 (bankAccount 폴백)
 * @returns {Promise<{bankName,accountNumber,accountHolder}|null>}
 */
export async function fetchDomesticBank(companyUid, legacyUserData = null) {
    try {
        const snap = await getDoc(doc(db, 'paymentProfiles', companyUid));
        const bank = snap.exists() ? snap.data().domesticBank : null;
        if (bank && (bank.accountNumber || bank.bankName)) return bank;
    } catch (e) { console.error('정산계좌 조회 실패(레거시 폴백):', e); }
    return (legacyUserData && legacyUserData.bankAccount) || null;
}

const domesticBank = { fetchDomesticBank };
export default domesticBank;
